import MapView from "./MapView";

function App() {
  return <MapView />;
}

export default App;